import React from 'react';
import { Resume } from './components/Resume';
export function App() {
  return <Resume data-id="element-0" />;
}